import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Stack, Text } from '@fluentui/react';
export const FreeTrialInfoText = (context)=>{
    return /*#__PURE__*/ _jsxs(Stack, {
        className: "mb-32",
        tokens: {
            childrenGap: 10
        },
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "ms-fontWeight-bold ms-fontSize-14",
                    children: context.loc('Global_Loc_free-trial')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "ms-fontWeight-regular ms-fontSize-14",
                    children: context.loc('Checkout_FreeTrialBillingStartDate')
                })
            })
        ]
    });
};
